module.exports = __webpack_public_path__ + "img/sad_panda4.a0e0e98d.gif";